define(
  'app/views/kala_promo_list',['app/setup'],
  function(takhfifan) {

  takhfifan.KalaPromoList = Backbone.View.extend({

    initialize: function(options) {
      var links = this.$el.find('.tkh-kala-promo__link[data-hover]');
      links.each(function () {
        var $this = $(this),
            $img = $("<img />");
        $img.prop("src", $this.data('hover'));
        $img.addClass("img-link__alt");
        $this.append($img);
      })
    }

  });
});

